
import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import NavBar from '@/components/NavBar';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DashboardLoading = () => {
  const [showHelp, setShowHelp] = useState(false);
  const [loadingTime, setLoadingTime] = useState(0);
  
  // Show help message after 3 seconds of loading (reduced from 5)
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHelp(true);
    }, 3000);
    
    // Track loading time
    const interval = setInterval(() => {
      setLoadingTime(prev => prev + 1);
    }, 1000);
    
    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);
  
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-50">
      <NavBar />
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="text-center max-w-md px-4">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-[#FF8C00] border-t-transparent mx-auto mb-6"></div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Loading your dashboard...
          </h2>
          <p className="text-gray-600 mb-4">
            Please wait while we prepare your personalized dashboard
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-500 mb-6">
            <div className="w-2 h-2 bg-[#FF8C00] rounded-full animate-pulse"></div>
            <span>Loading for {loadingTime} seconds</span>
          </div>
          
          {showHelp && (
            <Alert className="mt-8 bg-white/80 border border-orange-200 shadow-lg">
              <AlertCircle className="h-4 w-4 text-[#FF8C00]" />
              <AlertDescription className="text-sm text-left">
                <p className="font-medium text-gray-800 mb-2">Taking longer than expected?</p>
                <p className="text-gray-600 mb-3">This might be due to:</p>
                <ul className="text-sm text-gray-600 mb-4 space-y-1">
                  <li>• Database connection issues</li>
                  <li>• Network connectivity problems</li>
                  <li>• Authentication verification</li>
                </ul>
                <Button 
                  className="w-full bg-[#FF8C00] hover:bg-orange-600 text-white font-medium"
                  onClick={() => window.location.reload()}
                >
                  Refresh Page
                </Button>
              </AlertDescription>
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardLoading;
